import { useEffect, useState } from "react";

/* 這個函式是一個自定義 Hook，接受多個參數，包括 deviceStatus、filter、tableData 和 setDeviceTableData。
    deviceStatus：參數用於儲存裝置狀態的資訊。
    filter：參數是一個包含篩選條件的物件，其中鍵對應到 tableData 中的屬性，而值是一個字串數組，表示要篩選的值。
    tableData：參數是包含資料的數組，每個元素是一個物件。
    setDeviceTableData：參數是一個函式，用於設置篩選後的資料。
*/
export const useFilter = <P extends Record<string, any | string[]>>({
  deviceStatus,
  filter,
  tableData,
  setDeviceTableData,
}: {
  deviceStatus?: any;
  filter: Record<keyof P, string[]>;
  tableData: P[];
  setDeviceTableData: (arg: P[]) => void;
}) => {
  // 在 useEffect 內部，首先對 filter 物件進行清理（使用 cleanObject 函式），即刪除所有值為空的屬性。
  useEffect(() => {
    // remove keys with empty arrays

    const cleanFilter = cleanObject({ ...filter });
    if (Object.entries(cleanFilter).length === 0) {
      return setDeviceTableData(tableData);
    }

    const filteredData = [...tableData].filter((data) => {
      return Object.keys(cleanFilter).every((filterKey) => {
        // data value is a string
        if (typeof data[filterKey] === "string") {
          return cleanFilter[filterKey].includes(data[filterKey] as string);
        }
        // data value is an array
        else {
          return cleanFilter[filterKey].some((param) => data[filterKey]?.includes(param));
        }
      });
    });

    setDeviceTableData(filteredData);
  }, [filter, deviceStatus]);

  return [tableData];
};
// 這個函式用於清理物件，即刪除值為空的屬性。

export const cleanObject = (object: Record<string, string[]>) => {
  const result = { ...object };
  Object.keys(result).forEach((key) => {
    const value = result[key];
    if (!value?.length) {
      delete result[key];
    }
  });
  return result;
};

// var filterCondition = {
//   Health: ["Poor", "Good"],
//   Group: ["A", "B"],
// };
// var tableData = [
//   {
//     Group: ["A"],
//     Health: "Good",
//   },
//   {
//     Group: ["B"],
//     Health: "Good",
//   },
//   {
//     Group: ["A", "B"],
//     Health: "Poor",
//   },
// ];
